module.exports = __webpack_public_path__ + "static/img/jyyb.f1dca4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mimg/jyyb.png
// module id = dGvt
// module chunks = 4